export default __webpack_public_path__ + "static/graphic-icon-app-store-381df5f5604afd7b38ad90c64b0d1d22.webp";